import { paramsActionTypes } from './../actions/types';
import { cachedRequestByIdReducer } from './helpers';

const params = cachedRequestByIdReducer(paramsActionTypes, 'byJobId');
export default params;

const getParamState = state => state.params;
export const paramsByJobIds = state => getParamState(state).byJobId;
export const getParamsByJobId = (state, jobId) => paramsByJobIds(state)[jobId];


// WEBPACK FOOTER //
// src/reducers/params.js